import { Home } from 'lucide-react';
import { Link } from "react-router-dom";
import "./PageHeader.css";

const PageHeader = ({ title, url }) => {
  return (
<section className="page_header_section set_bg mt-2">
  <div className="page_overlay">
    <div className="container-fluid px-5">
      <div className="row">
        <div className="col-lg-12 text-center">
          <div className="page_header_text">
            <h2 className="page_title">{title}</h2>
            <div className="page_header_option">
              <Link to="/" className="breadcrumb_link">
                <Home size={18} style={{ marginRight: "6px", marginTop: "-2px" }} />
                Home
              </Link>
              <span className="separator">/</span>
              <span className="breadcrumb_current">{url || title}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  );
};

export default PageHeader;
